import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MensajeComponent } from './mensaje/mensaje.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { PaginadorComponent } from './paginador/paginador.component';
import { BuscadorComponent } from './buscador/buscador.component';
import { TabDirective } from './directives/tab.directive';
import { BotoneraComponent } from './botonera/botonera.component';
import { CalculadoraComponent } from './calculadora/calculadora.component';
import { CerradaPipe } from './pipes/cerrada.pipe';
import { BloqueadoPipe } from './pipes/bloqueado.pipe';
import { DomSeguroPipe } from './pipes/dom-seguro.pipe';
import { StringTiempoPipe } from './pipes/string-tiempo.pipe';
import { GaleriaComponent } from './galeria/galeria.component';
import { TelefonoPipe } from './pipes/telefono.pipe';
import { CicloPipe } from './pipes/ciclo.pipe';
import { NgxBarcodeModule } from 'ngx-barcode';
import { OcrComponent } from './ocr/ocr.component';
import { MonederoComponent } from './monedero/monedero.component';
import { MailComponent } from './mail/mail.component';
import { MenuRapidoComponent } from './menu-rapido/menu-rapido.component';
import { HistorialLineasComponent } from './historial-lineas/historial-lineas.component';
import { NuevoClienteComponent } from './nuevo-cliente/nuevo-cliente.component';
import { CarruselComponent } from './carrusel/carrusel.component';
import { ArbolFamiliasComponent } from './arbol-familias/arbol-familias.component';
import { CerradoPipe } from './pipes/cerrado.pipe';
import { ContabilizadaPipe } from './pipes/contabilizada.pipe';
import { HistorialUrlsComponent } from './historial-urls/historial-urls.component';
import { SelectorSerieComponent } from './selector-serie/selector-serie.component';
import { HoraUnixPipe } from './pipes/hora-unix.pipe';
import { FirmaPadComponent } from './firma-pad/firma-pad.component';
import { QrVerifactuComponent } from './qr-verifactu/qr-verifactu.component';


import  {NgxQRCodeModule}  from '@techiediaries/ngx-qrcode';
import { NuevoVehiculoComponent } from './nuevo-vehiculo/nuevo-vehiculo.component';
import { CccPipe } from './pipes/ccc.pipe';





@NgModule({
  declarations: [
       MensajeComponent,
       SpinnerComponent,
       PaginadorComponent,
       BuscadorComponent,
       TabDirective,
       BotoneraComponent,
       CalculadoraComponent,
       CerradaPipe,
       BloqueadoPipe,
       DomSeguroPipe,
       StringTiempoPipe,
       GaleriaComponent,
       TelefonoPipe,
       CicloPipe,
       OcrComponent,
       MonederoComponent,
       MailComponent,
       MenuRapidoComponent,
       HistorialLineasComponent,
       NuevoClienteComponent,
       CarruselComponent,
       ArbolFamiliasComponent,
       CerradoPipe,
       ContabilizadaPipe,
       HistorialUrlsComponent,
       SelectorSerieComponent,
       HoraUnixPipe,
       FirmaPadComponent,
       QrVerifactuComponent,
       NuevoVehiculoComponent,
       CccPipe,
  ],
  exports: [
       ArbolFamiliasComponent,
       BotoneraComponent,
       BuscadorComponent,
       CalculadoraComponent,
       CarruselComponent,
       CccPipe,
       CerradaPipe,
       CerradoPipe,
       CicloPipe,
       GaleriaComponent,
       HistorialLineasComponent,
       HistorialUrlsComponent,
       HoraUnixPipe,
       MailComponent,
       MensajeComponent,
       MenuRapidoComponent,
       MonederoComponent,
       NgxBarcodeModule,
       NuevoClienteComponent,
       OcrComponent,
       PaginadorComponent,
       SelectorSerieComponent,
       SpinnerComponent,
       StringTiempoPipe,
       TabDirective,
       TelefonoPipe,
       ContabilizadaPipe,
       FirmaPadComponent,
       QrVerifactuComponent,
       NuevoVehiculoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxQRCodeModule,
    
  ]
})
export class SharedModule { }
